/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";
import { FaCrown } from "react-icons/fa";
import useShowInsights from "../../../hooks/useShowInsights";

export const CrownIcon = ({ style }) => {
    return <FaCrown style={{
        color: "var(--yellow-400)", ...style
    }} />
}

function CrownSubscription({ style = {} }) {
    const { hasInsightPermission } = useShowInsights()
    return (
        <>
            {!hasInsightPermission ? (
                <CrownIcon style={style} />
            ) : ""}
        </>
    );
}

export default CrownSubscription;
